import type { SearchPatternsParams } from '@/entities/pattern';

import { buildSelector } from '@/shared/lib/store';

import type { PatternFilterSchema } from '../types/pattern-filter.schema';

const DEFAULT_FILTER: SearchPatternsParams = {} as SearchPatternsParams;

export const [usePatternFilterValues] = buildSelector(
    (state) => (state.patternFilter as PatternFilterSchema) ?? DEFAULT_FILTER,
);
